export function formatDate(date: Date) {
  const newDate = new Date(date).toISOString().split('T')[0]
  const [year, month, day] = newDate.split('-')
  return `${month}/${day}/${year}`
}

export function formatDateWithSlash(input: string) {
  const value = input.replace(/\D/g, '')
  if (value.length === 0) return ''
  if (value.length <= 2) return value
  if (value.length <= 4) return `${value.slice(0, 2)}/${value.slice(2)}`
  return `${value.slice(0, 2)}/${value.slice(2, 4)}/${value.slice(4, 8)}`
}

export function formatCurrency(input: string, allowDecimal = false) {
  let value = input.replace(/[^\d.]/g, '')

  if (allowDecimal) {
    const parts = value.split('.')

    if (parts.length > 2) {
      value = parts[0] + '.' + parts[1]
    } else if (parts[1] && parts[1].length > 2) {
      parts[1] = parts[1].slice(0, 2)
    }
    value = parts.join('.')
  } else {
    value = value.replace(/\D/g, '')
  }

  const formattedValue = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  return formattedValue ? `$ ${formattedValue}` : ''
}

export function isCompleteDate(input?: string) {
  // When the date input is in this format: MM/DD/YYYY the string length is 10
  // Otherwise we'll show an error while the user is typing
  return input?.length === 10
}

export function dateIsValid(dateStr: string) {
  const parsedDate = new Date(dateStr)

  if (isCompleteDate(dateStr) && isNaN(parsedDate.getTime())) {
    return false
  }

  return true
}

export function endDateIsValid(startDateStr: string, endDateStr: string) {
  const startDate = new Date(startDateStr)
  const endDate = new Date(endDateStr)

  let isValid = true

  if (isCompleteDate(endDateStr) && endDate.getTime() <= startDate.getTime()) {
    isValid = false
  } else {
    isValid = true
  }

  return isValid
}
